import { DateTime } from 'luxon';

export type DateInput = {
  year: number;
  month: number;
  day: number;
}
export function validateDate(date: DateInput) {
  let month_length = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let valid = false;
  let year = Number(date.year);
  let day = Number(date.day);
  let month = Number(date.month);
  if (year % 400 === 0 || (year % 100 != 0 && year % 4 == 0)) {
    month_length[1] = 29;
  }
  if (month >= 1 && month <= 12 && day > 0 && day <= month_length[month - 1]) {
    valid = true;
  }
  return valid;
}

export function dateInputToDateTime(dateInput: DateInput) {
  return DateTime.fromObject({
    year: dateInput.year,
    month: dateInput.month,
    day: dateInput.day,
  });
}
